import React, { Component } from 'react'
import styles from './styles'
import { withStyles } from '@material-ui/core'
import { Stepper, StepInfo, MobileVariant as MobileStepperVariant } from 'stepper'
import { Alert, Button, Typography } from 'foundations-library/components'

interface StepData { [key: string]: any }

/***/
/**
 *
 */
export interface UpdateData {
    completed: boolean
    gotoNext?: boolean
    saveData?: StepData
    disableNextButton?: () => boolean
}

/***/
/**
 *
 */
export interface StepComponentProps {
    currentData: StepData,
    update: (updateData: UpdateData) => void
    saveId: number
    stepIndex: number
}

interface RequestStep {
    id: string | number
    label: string
    secondaryLabel: string | Element
    title: string | Element
    component: any,
    bottomNavigationText: string
    passData: any
    additionalProps: Record<string, unknown>
    disableNextButton: () => boolean
    customBackButtonActionOnFirstStep?: () => void
}

/**
 * TODO
 * This component should be changed as soon as we have time.
 * It is clone of StepWizard component and it's pretty complicated, non intuitive, does things that should be handled in parent components,
 * has way too many props
 * In combination with Enrollment component (all above applied) and deadline we had, I left it for another time.
 * And that's why I'm sorry. Really. Sorry.
 *
 */
export interface StepsSaveData { [stepId: string]: StepData }

interface Props {
    classes
    steps: RequestStep[]
    error?: string
    onCloseError?(): unknown
    smallView: boolean
    className: string
    onSubmit: (stepsSaveData: StepsSaveData) => void
    extraData: any
    noSaveIdForBackClick: boolean
    disallowCompleteGaps?: boolean
    enableBackButtonOnFirstStep?: boolean,
    initialActiveStep?: string | null
}

interface State {
    activeStepId: string
    nextDisabled: boolean,
    completedIds: (string | number)[]
    saveId: string
    stepsSaveData: StepsSaveData
    gotoStepIndex: string | number
}

class StepWizard extends Component<Props, State> {
    noSaveIdForBackClick: boolean
    constructor (props) {
        super(props)
        const stepsSaveData: StepsSaveData = props.steps.reduce((data, step) => {
            data[step.id] = null
            return data
        }, {})
        this.state = {
            activeStepId: props.initialActiveStep && props.steps.some((x) => x.id === props.initialActiveStep)
                ? props.initialActiveStep
                : props.steps[0].id,
            nextDisabled: false,
            completedIds: [],
            saveId: null,
            stepsSaveData,
            gotoStepIndex: null
        }
    }

    // Called on step click
    // onStepClick = stepId => (this.state.completedIds.includes(stepId)) ? this.gotoStep(stepId) : null
    onStepClick = stepId => {
        if (!this.state.completedIds.includes(stepId)) return
        const { steps } = this.props
        const gotoStepIndex = steps.findIndex(s => s.id === stepId)
        this.setState({ saveId: `${Math.random()}#${gotoStepIndex}`, gotoStepIndex })
    }

    // Go to the step with id `stepId` if it isn't the current one
    gotoStep = stepId => {
        const { activeStepId } = this.state
        if (activeStepId === stepId) return
        this.props.onCloseError?.()
        this.setState({ activeStepId: stepId, saveId: null })
    }

    renderStepper = () => {
        const { smallView } = this.props
        const { completedIds, activeStepId } = this.state
        const steps = [...this.props.steps].map((s, i) => {
            const step: StepInfo = {
                ...s,
                done: completedIds.includes(s.id),
                active: s.id === activeStepId,
                error: false,
                title: <Typography variant='subtitle3' color={(s.id === activeStepId || completedIds.includes(s.id)) ? 'primary' : 'neutral-300'}>{s.label}</Typography>
            }
            return step
        })
        return (
            <div className='stepper-wrapper'>
                <Stepper
                    steps={steps}
                    mobileVariant={MobileStepperVariant.DOTS}
                    onStepClick={this.onStepClick}
                    onBackClick={this.onBackClick}
                    onNextClick={this.onNextClick}
                    smallView={smallView}
                />
            </div>
        )
    }

    updateStepState = (info: UpdateData) => {
        const { activeStepId, stepsSaveData } = this.state
        const completedIds = [...this.state.completedIds]
        const activeCompletedStepIndex = completedIds.findIndex(i => i === activeStepId)
        if (info.completed) {
            if (!completedIds.includes(activeStepId)) completedIds.push(activeStepId)
        } else if (activeCompletedStepIndex !== -1) {
            completedIds.splice(activeCompletedStepIndex, this.props.disallowCompleteGaps ? completedIds.length : 1)
        }
        stepsSaveData[activeStepId] = info.saveData
        if ('disableNextButton' in info) this.setState({ nextDisabled: info.disableNextButton() })
        this.setState({ completedIds, stepsSaveData }, () => {
            if (!('gotoNext' in info)) return
            if (info.gotoNext) this.switchStep()
            else this.setState({ gotoStepIndex: null })
        })
    }

    switchStep = (): void => {
        const { steps } = this.props
        const { activeStepId } = this.state
        const currentStepIndex = steps.findIndex(s => s.id === activeStepId)
        let { gotoStepIndex } = this.state
        gotoStepIndex = (gotoStepIndex || gotoStepIndex === 0) ? gotoStepIndex : (currentStepIndex === steps.length - 1 ? 'submit' : currentStepIndex + 1)
        if (gotoStepIndex === 'submit') return this.props.onSubmit(this.state.stepsSaveData)
        const nextStep = steps[gotoStepIndex]
        this.gotoStep(nextStep.id)
    }

    renderContent = () => {
        const { steps, smallView, extraData } = this.props
        const { activeStepId, saveId, stepsSaveData, gotoStepIndex } = this.state
        const currentStep = steps.find(s => s.id === activeStepId)
        let content = null
        if (currentStep) {
            const StepComponent = currentStep.component
            content = (
                <StepComponent
                    passData={{ ...stepsSaveData, extraData }}
                    update={this.updateStepState}
                    saveId={saveId}
                    smallView={smallView}
                    stepIndex={steps.findIndex(s => s.id === activeStepId)}
                    gotoStepIndex={gotoStepIndex}
                    {...currentStep.additionalProps}
                />
            )
        }
        return (
            <div id='step-wizard-content-root' className='content'>
                {/* <div className='title'><Typography variant='subtitle3'>{title}</Typography></div> */}
                {content}
            </div>
        )
    }

    onBackClick = () => {
        const { steps } = this.props
        const { activeStepId } = this.state
        const currentStepIndex = steps.findIndex(s => s.id === activeStepId)
        if (currentStepIndex === 0) return
        const gotoStepIndex = currentStepIndex - 1
        if (this.props.noSaveIdForBackClick) {
            this.setState({ gotoStepIndex }, this.switchStep)
        } else {
            this.setState({ saveId: `${Math.random()}#${gotoStepIndex}`, gotoStepIndex })
        }
    }

    onNextClick = () => {
        const { steps } = this.props
        const { activeStepId } = this.state
        const currentStepIndex = steps.findIndex(s => s.id === activeStepId)
        const gotoStepIndex = currentStepIndex + 1 === steps.length ? 'submit' : currentStepIndex + 1
        this.setState({ saveId: `${Math.random()}#${gotoStepIndex}`, gotoStepIndex })

        const element = document.getElementById('wizard')
        if (element) element.scrollTo({ top: 0, behavior: 'smooth' })
    }

    renderFooter = (classes) => {
        const { steps } = this.props
        const { activeStepId, nextDisabled } = this.state
        const currentStepIndex = steps.findIndex(s => s.id === activeStepId)
        const currentStep = steps[currentStepIndex]
        const customBackButtonActionOnFirstStep = currentStep.customBackButtonActionOnFirstStep
        const nextButtonText = currentStepIndex === (steps.length - 1) ? 'Submit' : 'Next'

        return <div className={classes.buttonsContainer}>
            {!(currentStepIndex === 0 && !this.props.enableBackButtonOnFirstStep)
                ? <Button
                    disabled={currentStepIndex === 0 && !this.props.enableBackButtonOnFirstStep}
                    onClick={customBackButtonActionOnFirstStep || this.onBackClick}
                    color='neutral'
                    variant='outlined'
                >{currentStepIndex === 0 ? 'Cancel' : 'Back'}</Button>
                : null}
            <Button
                onClick={this.onNextClick}
                color='primary'
                className={classes.nextBtn}
                disabled={nextDisabled}
                data-testid={nextButtonText === 'Submit' ? 'bottom-navigation-submit-button' : null}
            >{nextButtonText}</Button>
        </div>
    }

    render = () => {
        const { classes, smallView, className } = this.props
        let classNames = `${classes.wrapper} ${smallView ? 'mobile' : ''}`
        if (className) classNames += ` ${className}`
        return (
            <div className={classNames} id='wizard'>
                {this.renderStepper()}
                {
                    this.props.error &&
                    typeof this.props.error === 'string'
                        ? <Alert
                            onClose={this.props.onCloseError}
                            marginY={20}
                            autoscroll
                        >
                            {this.props.error}
                        </Alert>
                        : <></>
                }
                {this.renderContent()}
                {this.renderFooter(classes)}
            </div>
        )
    }
}

StepWizard.defaultProps = {
    smallView: false
}

export default withStyles(styles)(StepWizard)
